import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { COLORS } from "assets/styles/colors";
import { Icons } from "assets/svgs";
import { PrimaryButton } from "common";
import { clientRoutes } from "router/routes";
import { getNotifications } from "store/client-slice/actions";
import { clientSelectors } from "store/client-slice/selectors";
import { ownerPortalPropertyActions } from "store/owner-portal-property-slice/slice";
import { toggleClassOnRoot } from "utils/helpers";

import * as S from "./styled";

export const SuccessModal = () => {
  const { account } = useSelector(clientSelectors);

  const [firstAnimation, setFirstAnimation] = useState(true);
  const [secondAnimation, setSecondAnimation] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navigateToStep1 = () => {
    toggleClassOnRoot();
    dispatch(ownerPortalPropertyActions.changeStep(0));
  };

  const handleAnimate = () => setSecondAnimation(true);

  const handleAnimationEnd = () => {
    setFirstAnimation(false);
    setSecondAnimation(false);
  };
  window.dataLayer.push({
    event: "user_email",
    email: account?.email,
  });

  const handleExit = () => {
    toggleClassOnRoot();
    dispatch(ownerPortalPropertyActions.setIsOpenSuccessModal(false));
    navigate(`${clientRoutes.prefix}${clientRoutes.properties}`);
  };

  useEffect(() => {
    return () => dispatch(getNotifications());
  }, []);

  return (
    <S.Container onClick={handleAnimate}>
      <S.Content
        className={`${secondAnimation ? "second-animation" : ""} ${firstAnimation ? "first-animation" : ""}`}
        onAnimationEnd={handleAnimationEnd}
        onClick={(e) => e.stopPropagation()}
      >
        <S.BoxCenter>
          <S.IconWrapper>
            <Icons.CheckIcon size={45} />
          </S.IconWrapper>
        </S.BoxCenter>
        <S.BoxCenter>
          <S.Description>Your property address has been successfully saved!</S.Description>
        </S.BoxCenter>
        <S.BoxCenter>
          <S.ButtonsWrapper>
            <PrimaryButton
              eventHandler={navigateToStep1}
              label="add more properties"
              styles={{
                backgroundColor: COLORS.deepDark,
                height: 50,
              }}
            />
            <PrimaryButton
              eventHandler={handleExit}
              label="exit"
              styles={{
                backgroundColor: COLORS.white,
                color: COLORS.dark,
                border: `1px solid ${COLORS.dark}`,
                height: 50,
              }}
            />
          </S.ButtonsWrapper>
        </S.BoxCenter>
      </S.Content>
    </S.Container>
  );
};
